export default "__VITE_ASSET__BzaPuui1__"